import styled from "@emotion/styled";
import ReactPlayer from "react-player";
import { EcoaMediaImageItemSpec, EcoaMediaVideoItemSpec } from "maven-lib/dist/consts/edc";

const StyledMediaItems = styled.div<{ placement?: "HORIZONTAL" | "VERTICAL"; numberOfItems: number }>`
  display: flex;
  flex-direction: ${({ placement }) => (placement === "HORIZONTAL" ? "row" : "column")};
  gap: 10px;

  > * {
    max-width: ${({ placement, numberOfItems }) => (placement === "HORIZONTAL" ? 100 / numberOfItems : 100)}%;
    height: auto !important;
  }
`;

const StyledMediaItem = styled.div<{ alignment?: "LEFT" | "RIGHT" | "CENTER"; maxWidthInPx?: number }>`
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;

  min-width: 0;
  max-width: ${({ maxWidthInPx }) => (maxWidthInPx ? `${maxWidthInPx}px` : "100%")};

  ${({ alignment }) => alignment === "LEFT" && "text-align: left;"}
  ${({ alignment }) => alignment === "RIGHT" && "text-align: right;"}
  ${({ alignment }) => alignment === "CENTER" && "text-align: center;"}

  video {
    width: 100% !important;
    height: unset !important;
  }
`;

const StyledMediaImage = styled.img`
  max-width: 100%;
  cursor: pointer;
  object-fit: contain;
`;

function MediaItemImage({ url }: { url: string }) {
  return (
    <StyledMediaImage
      src={url}
      alt="Image"
      onClick={() => {
        const width = Math.min(window.innerWidth * 0.7, 1024);
        const height = (width * 9) / 16;

        window.open(url, undefined, `width=${width}},height=${height}`);
      }}
    />
  );
}

function MediaItemVideo({ url }: { url: string }) {
  return <ReactPlayer url={url} controls width="100%" height="100%" />;
}

export function EcoaMediaItems({
  media,
  placement,
  alignment,
}: {
  media?: Array<EcoaMediaImageItemSpec | EcoaMediaVideoItemSpec>;
  placement?: "HORIZONTAL" | "VERTICAL";
  alignment?: "LEFT" | "RIGHT" | "CENTER";
}) {
  if (!media || media.length === 0) return null;

  const mediaItems = media.filter((item) => "url" in item && item.url);

  return (
    <StyledMediaItems placement={placement} numberOfItems={mediaItems.length}>
      {mediaItems.map((mediaItem, index) => {
        const mediaItemUrl = "url" in mediaItem ? mediaItem.url : undefined;

        if (!mediaItemUrl) return null;
        return (
          <StyledMediaItem key={index} alignment={alignment} maxWidthInPx={mediaItem.maxWidthInPx}>
            {mediaItem.type === "IMAGE" && <MediaItemImage url={mediaItemUrl} />}
            {mediaItem.type === "VIDEO" && <MediaItemVideo url={mediaItemUrl} />}
          </StyledMediaItem>
        );
      })}
    </StyledMediaItems>
  );
}
